import L from 'leaflet'
import "leaflet.markercluster";
import {initSliders} from 'slider';
import utils from 'utils';

'use strict';

class CheckoutMap {
  constructor(elem) {
    this.elem = elem;
    this.isZonesMap = this.elem.classList.contains('js-checkout-zones-map');
    this.mapElem = this.elem.querySelector('[data-checkout-map]');
    this.detailsModal = this.elem.querySelector('[data-checkout-map-modal]');
    this.closeModalBtn = this.elem.querySelector('[data-checkout-map-close-modal]');
    this.mapInitialized = false;
    this.translations = JSON.parse(this.elem.dataset.translations);
    this.location = {};
    this.units = [];
    this.unitsMarkers = [];
    this.mapTiles = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, Points &copy 2012 LINZ',
      maxZoom: 20,
    });
    this.markerCustomIcon = {
      iconUrl: '/themes/siblu/dist/assets/svg/marker.svg',
      shadowUrl: null,
      iconSize: [20, 30], // size of the icon
      shadowSize: [50, 64], // size of the shadow
      iconAnchor: [10, 30], // point of the icon which will correspond to marker's location
      shadowAnchor: [0, 0], // the same for the shadow
      popupAnchor: [7, -0] // point from which the popup should open relative to the iconAnchor
    };
    this.chooseYourUnitForm = document.querySelector('#choose-your-unit-form');
    this.isMobile = utils.mq.sm.matches; 

    this.initData();
    this.setMarkers();
    this.initMap();
    this.events();
  }

  initData() {
    if(window.chooseYourUnitMarkers && !this.isZonesMap) {
      this.location = window.chooseYourUnitMarkers.village;
      this.units = window.chooseYourUnitMarkers.units;
    }  else if (window.chooseYourUnitZoneMarkers && this.isZonesMap) {
      this.location = window.chooseYourUnitZoneMarkers.village;
      this.units = window.chooseYourUnitZoneMarkers.units;
    }
  }

  updateMap() {
    this.initData();

    if((!this.isZonesMap && window.chooseYourUnitMarkers) || (this.isZonesMap && window.chooseYourUnitZoneMarkers)) {
      if (this.units.length > 0) {
        this.setMarkers();
        this.initMap();
      }
    }
  }

  setMarkers() {
    this.unitsMarkers = [];

    if (this.units.length > 0) {
      for (let unit of this.units) {
        this.unitsMarkers.push({
          ...unit,
          id: unit.unitId,
          lat: unit.lat,
          lng: unit.lng,
          detailsUrl: unit.detailsUrl,
        });
      }
    }
  }

  attachTriggerChooseUnit() {
    const triggersChooseUnit = this.detailsModal.querySelectorAll('[data-trigger-unit]');

    triggersChooseUnit.forEach((triggerChooseUnit) => {
      triggerChooseUnit.addEventListener('click', (ev) => {
        const resourceInput = this.chooseYourUnitForm.querySelector('[data-drupal-selector="edit-resource"]');
        const unitInput = this.chooseYourUnitForm.querySelector('[data-drupal-selector="edit-unit"]');
        const submitInput = this.chooseYourUnitForm.querySelector('[data-drupal-selector="edit-submit"]');

        resourceInput.value = parseInt(ev.currentTarget.getAttribute('data-resource'));
        unitInput.value = parseInt(ev.currentTarget.getAttribute('data-unit'));

        submitInput.click();
      });
    });
  }

  events() {
    this.elem.addEventListener('update-choose-your-unit-markers', (e) => {
      this.updateMap();
    });

    this.closeModalBtn.addEventListener('click', () => {
      this.elem.classList.remove('modal-open');
      this.detailsModal.replaceChildren();
    });
  }

  mapModal(fetchUrl) {
    /* TODO: here call marker detail url */
    fetch(fetchUrl).then((response) => {
      return response.json();
    }).then((data) => {
      this.elem.classList.add('modal-open');
      return this.detailsModal.innerHTML = data.content;
    }).then((data) => {
      initSliders();
      this.attachTriggerChooseUnit();
    });
  }

  mapTooltip(data) {
    let zone = (data.zone ? `<span class="label-purple d-f ai-c tt-u lh-xxs fw-700 c-purple bw-xs bc-purple bs-s brad-xs pin-xs pbl-xxs">${data.zone}</span>` : '');

    return `<div class="ff-main">
      <img src="${data.image}" alt="">
      <div class="p-m fs-xxxxs c-darkest lh-xxs">
        <span class="c-main tt-u fw-700">${data.category}</span>
        <h2 class='ff-scd fs-m c-darker lh-xxs fw-700'>${data.model}</h2>
        <div class="d-f ai-c jc-sb mt-xxxs mb-s">
          <span class="d-b pr-xxs fw-700">${data.name}</span>
          ${zone}
        </div>
        <div class="d-f ai-fe jc-fe">
          <span class="fw-700 d-ib pr-xxxs">${data.dates}</span>
          <span>${data.nights}</span>
        </div>
        <span class="d-b ta-r c-main fw-700 fs-s">${data.price}</span>
        ${this.translations.tailoredOption ? `<span class="d-b ta-r c-light">${this.translations.tailoredOption}</span>` : '' }
      </div>
    </div>`;
  }


  getLocationBounds() {
    return L.latLng(parseFloat(this.location.lat), parseFloat(this.location.lng));
  }

  initMap() {
    if(this.mapInitialized) {
      this.map.remove();
      this.mapInitialized = false;
    }

    if (Object.keys(this.location).length > 0) {
      this.mapInitialized = !this.mapInitialized;
      const latlng = this.getLocationBounds();
      this.map = L.map(this.mapElem, { center: latlng, zoom: 16, layers: [this.mapTiles] });
    }

    if(this.unitsMarkers.length > 0) {
      this.updateMapMarkers();
    }
  }

  updateMapMarkers() {
    if(this.mapInitialized && this.unitsMarkers.length > 0) {
      const customIcon = L.icon(this.markerCustomIcon);

      /* SET MAKERS CLUSTER GROUP */
      const markerClusterGroup = L.markerClusterGroup({ disableClusteringAtZoom: 16, spiderfyOnMaxZoom: false });

      /* SET MARKERS */
      for (let i = 0; i < this.unitsMarkers.length; i++) {
        let unitMarker = this.unitsMarkers[i];
        let marker = L.marker(L.latLng(unitMarker.lat, unitMarker.lng), { icon: customIcon });
        marker.id = unitMarker.id;

        marker.addEventListener('click', e => {
          this.mapModal(unitMarker.detailsUrl);
        });

        let markerTooltip = marker.bindPopup(this.mapTooltip(unitMarker));
        if(!this.isMobile) {
          marker.addEventListener('mouseover', e => markerTooltip.openPopup());
          marker.addEventListener('mouseout', e => markerTooltip.closePopup());
        }
        markerClusterGroup.addLayer(marker);
      }

      /* SET MAP BOUNDS */
      this.mapBounds = markerClusterGroup.getBounds();
      // Not animated so that clusters are computed at the final zoom level.
      this.map.fitBounds(this.mapBounds, { maxZoom: 17, padding: [30, 30], animate: false });

      /* SET MAP LAYER */
      this.map.addLayer(markerClusterGroup);

      if (this.isZonesMap) {
        this.openDefaultTooltip(markerClusterGroup);
      }
    }
  }

  /* OPEN A UNIT TOOLTIP BY DEFAULT TO SHOW THAT MARKERS ARE INTERACTIVE */
  openDefaultTooltip(markerClusterGroup) {
    const markers = markerClusterGroup.getLayers();
    const visibleMarker = markers.find(marker => markerClusterGroup.getVisibleParent(marker) === marker);

    if (visibleMarker) {
      visibleMarker.openPopup();
    } else if (markers.length > 0) {
      markerClusterGroup.zoomToShowLayer(markers[0], () => markers[0].openPopup());
    }
  }
}


export default CheckoutMap;
